import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useLang } from '../context/LangContext';
import { toast } from 'react-toastify';
import './Auth.css';

export function ForgotPasswordPage() {
  const { t } = useLang();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
      toast.success('✅ Password reset email sent!');
    } catch (err) { toast.error(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <span className="auth-om">ॐ</span>
          <h1 className="auth-title-hi">राघवेंद्र पूजन भंडार</h1>
          <p className="auth-subtitle">{t({ hi:'पासवर्ड रीसेट करें', en:'Reset Password' })}</p>
        </div>
        {sent ? (
          <div style={{ textAlign:'center', padding:'1rem 0' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:'.75rem' }}>📧</div>
            <h3 style={{ color:'var(--maroon)', marginBottom:'.5rem' }}>Email Sent!</h3>
            <p style={{ fontSize:'.82rem', color:'var(--text-muted)', lineHeight:1.7 }}>
              {t({ hi:'पासवर्ड रीसेट लिंक आपके ईमेल पर भेज दी गई है। 10 मिनट में लिंक expire हो जाएगी।', en:'A password reset link has been sent to your email. The link expires in 10 minutes.' })}
            </p>
            <Link to="/login" className="btn btn-primary btn-full" style={{ marginTop:'1.25rem', display:'inline-flex' }}>
              ← {t({ hi:'लॉगिन पर वापस', en:'Back to Login' })}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ fontSize:'.82rem', color:'var(--text-muted)', marginBottom:'1.25rem', lineHeight:1.6 }}>
              {t({ hi:'अपना ईमेल पता दर्ज करें। हम आपको पासवर्ड रीसेट लिंक भेजेंगे।', en:'Enter your email address and we\'ll send you a password reset link.' })}
            </p>
            <div className="form-group">
              <label className="form-label">{t({ hi:'ईमेल', en:'Email Address' })} *</label>
              <input type="email" className="form-input" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@example.com" autoFocus />
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? <span className="auth-spinner" /> : `📧 ${t({ hi:'रीसेट लिंक भेजें', en:'Send Reset Link' })}`}
            </button>
            <div className="auth-switch" style={{ marginTop:'1rem' }}>
              <Link to="/login">← {t({ hi:'लॉगिन पर वापस', en:'Back to Login' })}</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useLang();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error('Passwords do not match'); return; }
    if (form.password.length < 6) { toast.error('Minimum 6 characters'); return; }
    setLoading(true);
    try {
      await authAPI.resetPassword(token, form.password);
      toast.success('✅ Password reset successfully! Please log in.');
      navigate('/login');
    } catch (err) { toast.error(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <span className="auth-om">ॐ</span>
          <h1 className="auth-title-hi">राघवेंद्र पूजन भंडार</h1>
          <p className="auth-subtitle">{t({ hi:'नया पासवर्ड बनाएं', en:'Create New Password' })}</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">{t({ hi:'नया पासवर्ड', en:'New Password' })} *</label>
            <input type="password" className="form-input" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={6} placeholder="Min. 6 characters" autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">{t({ hi:'पासवर्ड दोहराएं', en:'Confirm Password' })} *</label>
            <input type="password" className="form-input" value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} required placeholder="Repeat new password" />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? <span className="auth-spinner" /> : `🔐 ${t({ hi:'पासवर्ड बदलें', en:'Reset Password' })}`}
          </button>
        </form>
      </div>
    </div>
  );
}
